import { FCX, ID, SelectSingle } from "@datassential/platform-ui-lib";
import { useCallback, useEffect, useMemo } from "react";
import { useHomeLtos } from "@apiHooks/useHomeLtos";
import HomeSectionSubTitle from "@pages/Home/components/HomeSectionSubTitle";
import HomeLtosSection from "@pages/Home/components/HomeLtosSection";
import useLocalStorageState from "@hooks/useLocalStorageState";
import HomeSectionLoader from "@pages/Home/components/HomeSectionLoader";

interface HomeFoodsLtosProps {
    excludeAllCategory?: boolean;
}

const HomeFoodsLtos: FCX<HomeFoodsLtosProps> = ({ excludeAllCategory }) => {
    const selectedCategoryIdValueConverter = useCallback(
        (value: string | null): ID | null => {
            return value !== null ? Number(value) as ID : null;
        },
        [],
    )
    const [selectedCategoryId, setSelectedCategoryId] = useLocalStorageState<ID | null>(
        'home-ltos-tab',
        null,
        selectedCategoryIdValueConverter
    );
    const { isLoading, data } = useHomeLtos();

    const categories = useMemo(
        () => {
            const all = data?.categories ?? [];
            return excludeAllCategory ? all.filter(c => c.id !== 0) : all;
        },
        [data, excludeAllCategory]
    );

    useEffect(() => {
        if (categories.length > 0 && !selectedCategoryId) {
            setSelectedCategoryId(categories[0].id);
        }
    }, [categories, selectedCategoryId, setSelectedCategoryId]);

    const headerContent = useMemo(() => (
        <>
            <HomeSectionSubTitle>Launches</HomeSectionSubTitle>
            <SelectSingle
                className="no-rem"
                value={selectedCategoryId}
                setValue={setSelectedCategoryId}
                options={categories}
                dropdownProps={{
                    style: {
                        maxHeight: 300,
                        overflowX: 'hidden',
                    },
                    className: 'no-scroll-override',
                    place: "bottom-start",
                }}
                fieldProps={{
                    style: {
                        minWidth: 200,
                    },
                }}
                hasSearch
            />
        </>
    ), [categories, selectedCategoryId, setSelectedCategoryId]);

    if (isLoading) return <HomeSectionLoader />;

    return (
        <HomeLtosSection
            data={data}
            categoryId={selectedCategoryId}
            headerContent={headerContent}
        />
    );
};

export default HomeFoodsLtos;